module.exports = __webpack_public_path__ + "img/Meir_Hospital.f307d6b0.svg";